(function () {
    'use strict';

    /**
     * @module 
     */
    angular.module('ib-flexibilization-module', [
        'ib-flexibilization-search-module',
        'ib-flexibilization-availability-module',
        'ib-flexibilization-confirmation-module',
        'ib-flexibilization-disruption-module',
        'ib-flexibilization-slices-module',
        'ib-flexibilization-total-module',
        'ib-flexibilization-info-module',
        'ib-flexibilization-info-voucher-digital-module',
        'ib-flexibilization-calendar-module',
        'ib-flexibilization-code-confirmation-module',
        'ib-flexibilization-slice-confirmation-module',
        'ib-flexibilization-availability-trip-module'
    ]);
})();